
import i18n from '@/i18n/index'

const roomsManager = [
  {
    path: '/roomsManager',
    component: () => import('@/views/roomsManager/index.vue'),
    meta: { name: i18n.t('menu.informationManagement'), allowBreadcrumbRedirect: false },
    children: [
      {
        // 演出列表
        path: '/roomsManager/room',
        component: () => import('@/views/roomsManager/room/index.vue'),
        meta: { name: i18n.t('menu.showList'), allowBreadcrumbRedirect: true },
        redirect: {
          name: 'hotelRoomList'
        },
        children: [
          {
            // 列表
            path: 'list',
            name: 'hotelRoomList',
            component: () => import('@/views/roomsManager/room/list/index.vue'),
            meta: { name: i18n.t('text.list'), keepAlive: true }
          },
          {
            // 新增
            path: 'add',
            name: 'hotelRoomAdd',
            component: () => import('@/views/roomsManager/room/add/index.vue'),
            meta: { name: i18n.t('text.add'), keepAlive: false }
          },
          {
            // 编辑
            path: 'edit/:id',
            name: 'hotelRoomEdit',
            component: () => import('@/views/roomsManager/room/edit/index.vue'),
            meta: { name: i18n.t('text.edit'), keepAlive: false }
          },
          {
            // 详情
            path: 'detail/:id',
            name: 'hotelRoomDetail',
            component: () => import('@/views/roomsManager/room/detail/index.vue'),
            meta: { name: i18n.t('text.detail'), keepAlive: false }
          }
        ]
      },
      {
        // 演出列表
        path: '/roomsManager/room_policy',
        component: () => import('@/views/roomsManager/room_policy/index.vue'),
        meta: { name: i18n.t('menu.showList'), allowBreadcrumbRedirect: true },
        redirect: {
          name: 'hotelRoomPolicyList'
        },
        children: [
          {
            // 列表
            path: 'list',
            name: 'hotelRoomPolicyList',
            component: () => import('@/views/roomsManager/room_policy/list/index.vue'),
            meta: { name: i18n.t('text.list'), keepAlive: true }
          },
          {
            // 新增
            path: 'add',
            name: 'hotelRoomPolicyAdd',
            component: () => import('@/views/roomsManager/room_policy/add/index.vue'),
            meta: { name: i18n.t('text.add'), keepAlive: false }
          },
          {
            // 编辑
            path: 'edit/:id',
            name: 'hotelRoomPolicyEdit',
            component: () => import('@/views/roomsManager/room_policy/edit/index.vue'),
            meta: { name: i18n.t('text.edit'), keepAlive: false }
          },
          {
            // 详情
            path: 'detail/:id',
            name: 'hotelRoomPolicyDetail',
            component: () => import('@/views/roomsManager/room_policy/detail/index.vue'),
            meta: { name: i18n.t('text.detail'), keepAlive: false }
          },
          {
            path: ':room_policy_id?/prices',
            name: 'roomPolicyPriceList',
            component: () => import('@/views/roomsManager/room_policy_price/list/index.vue'),
            meta: { name: i18n.t('text.list'), keepAlive: true }
          },
          {
            path: ':room_policy_id?/prices/add',
            name: 'roomPolicyPriceAdd',
            component: () => import('@/views/roomsManager/room_policy_price/add/index.vue'),
            meta: { name: i18n.t('text.add'), keepAlive: false }
          },
          {
            path: ':room_policy_id?/prices/:id',
            name: 'roomPolicyPriceEdit',
            component: () => import('@/views/roomsManager/room_policy_price/edit/index.vue'),
            meta: { name: i18n.t('text.edit'), keepAlive: false }
          },
          {
            path: ':room_policy_id?/prices/:id',
            name: 'roomPolicyPriceDetail',
            component: () => import('@/views/roomsManager/room_policy_price/detail/index.vue'),
            meta: { name: i18n.t('text.detail'), keepAlive: false }
          }
        ]
      }
    ]
  }
]

export default roomsManager
